module.exports = __webpack_public_path__ + "img/barMark2.04814418.png";